export enum CaseCloseState {
  CLOSE_REASON = "closeReason",
  DISPLAY_NAME = "displayName",
}
